import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {ServiceCopyProperties} from "../../models/service-copy-properties";
import {Observable} from "rxjs";
import {ClassificationType} from "../../models/classification-type";

@Injectable()
export class ServiceCopyControllerService {
  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public exportService(serviceId: string, serviceName: string) {
    return this.http.get(this.baseUrl + "download_service/" + serviceId + "/name/" + serviceName, { responseType: "blob" });
  }

    public exportServiceWithProperties(serviceId: string, serviceCopyProperties: ServiceCopyProperties) {
        const body = JSON.stringify(serviceCopyProperties);
        return this.http.post(this.baseUrl + "download_service/" + serviceId , body, { responseType: "blob" });
    }

    public getServiceClassifications(serviceId: string): Observable<ClassificationType[]> {
        return this.http.get(this.baseUrl + "download_service/" + serviceId + "/service_catalogs") as Observable<ClassificationType[]>;
    }

    public importServiceWithCatalogs(serviceId: string, catalogData: any) {
        const body = JSON.stringify(catalogData);
        return this.http.post(this.baseUrl + "upload_service" , body, { responseType: "text" });
    }
}
